import { useRef, createRef } from 'react';

const useCreateRefsForClick = (refsCount: number) => {
  const refs = useRef<React.RefObject<HTMLDivElement>[]>(
    Array.from({ length: refsCount }, () => createRef<HTMLDivElement>())
  );

  return {
    refs: refs.current,
  };
};

export const handlerRefClick =
  (element: React.RefObject<HTMLDivElement>) => () => {
    if (element.current) {
      element.current?.scrollIntoView({ behavior: 'smooth' });
    }
  };

export default useCreateRefsForClick;
